'use strict';

const microsoftTeams = require('@microsoft/teams-js'),
	defaultMapContent = require('../../models/default-map-content'),
	MicrosoftTeamsShim = require('../../models/microsoft-teams-shim'),
	MicrosoftTeamsModel = require('../../models/microsoft-teams-model'),
	PKCEUtils = require('../../models/pkce-utils'),
	microsoftOAuthParams = require('../../models/microsoft-oauth-params'),
	sanitiseMapTitle = require('../../models/sanitise-map-title');

module.exports = function microsoftTeamsStart({config, navigatorShim, storage, goldApi, s3Api, ajaxPromise} = {}) {
	if (!config || !navigatorShim || !storage || !goldApi || !s3Api || !ajaxPromise) {
		throw new Error('invalid-args');
	}
	const microsoftTeamsShim = new MicrosoftTeamsShim({microsoftTeams}),
		pkceUtils = new PKCEUtils({navigatorShim, clientId: config.microsoftAppId, ajaxPromise, logger: console, interactionRequiredErrors: microsoftOAuthParams.interactionRequiredErrors}),
		microsoftTeamsModel = new MicrosoftTeamsModel({config, storage, navigatorShim, goldApi,  microsoftTeamsShim,  sanitiseMapTitle,  defaultMapContent,  s3Api,  pkceUtils});

	return {microsoftTeamsShim, microsoftTeamsModel};

};
